export default __webpack_public_path__ + "src/images/packages/maison-de-plage/b349b6176d81b6f1caabb3d9b08069ff-1.jpg";